<template>
    <div id="helpList" class="app-inner">
      <div class="public-btn-div flex align-cen">
      <div class="public-add"  @click="addHelp">
        新增帮助
      </div>
    </div>
       <div class="p-tit-c">
        <div class="businessList-filter">
         <div class="businessList-filter-list flex align-cen">
             <div class="fl-le flex align-cen">
          <div class="label">课程名称：</div>
          <div class="el-select1">
            <el-input placeholder="请输入帮助课程名称" v-model="search" clearable> </el-input>
          </div>
         </div>
          <div class="fl-rt flex align-cen">
          <div class="label">帮助课程ID：</div>
          <div class="el-select1">
          <el-input placeholder="请输入帮助课程ID" v-model="search1" clearable> </el-input>
          </div>
         </div>
          <div class="fl-rt flex align-cen">
          <div class="label">关联应用名称：</div>
          <div class="el-select1">
          <el-input placeholder="请输入关联应用名称" v-model="search2" clearable> </el-input>
          </div>
         </div>
         <div class="fl-rt flex align-cen">
          <div class="label">关联应用ID：</div>
          <div class="el-select1">
          <el-input placeholder="请输入关联应用ID" v-model="search3" clearable> </el-input>
          </div>
         </div>
         </div>
      <div class="businessList-filter-list flex align-cen">
        <div class="fl-le flex align-cen">
          <div class="label">关联应用分类：</div>
          <el-cascader
                :options="itemList1"
                v-model="seletvalue"
                @change="classSelect"
                separator="--"
                clearable
                change-on-select
                 ref="cascaderRef"
                >
            </el-cascader>
        </div>
      </div>
      <div class="businessList-filter-list flex align-cen">
        <div class="label">启用状态：</div>
        <div
          style="color: red; padding-right: 20px; cursor: pointer"
          @click="allradio('')"
        >
          不限
        </div>
        <el-radio v-model="radio" label="1" @change="gethisInfo">启用中</el-radio>
        <el-radio v-model="radio" label="0" @change="gethisInfo">禁用</el-radio>
      </div>
        <div class="businessList-filter-list flex align-cen">
                    <div class="label">应用官网分类：</div>
                    <div
                      style="color: red; padding-right: 20px; cursor: pointer"
                      @click="allradio(1)"
                    >
                      不限
                    </div>
                    <el-radio v-model="radio1" label="1" @change="gethisInfo">和隆优化官网</el-radio>
                    <el-radio v-model="radio1" label="2" @change="gethisInfo">和隆软件官网</el-radio>
                  </div>
      <div class="businessList-filter-list flex align-cen">
        <div class="label">发布时间：</div>
        <el-date-picker
          v-model="value2"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions2"
          @change="dataSuccess"
        >
        </el-date-picker>
      </div>
           <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="searchList">
          搜索
        </div>
        <div class="public-btn-small-text" @click="reset">
          重置筛选条件
        </div>
      </div>
    </div>
     </div>
    <div class="businessList-container">
       <div class="helpList-container-table">
                 <el-table
            :data="itemList"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
             <el-table-column
            prop="sort"
            label="排序"
           align="center"
           fixed
            width="100"
             >
            </el-table-column>
            <el-table-column
            prop="id"
            label="帮助课程ID"
           align="center"
            width="200"
             >
            </el-table-column>
                <el-table-column label="应用官网分类" align="center"  width="200">
          <template slot-scope="scope">
            <span>
              {{$util.offType(scope.row.officialType)}}
            </span>
          </template>
         </el-table-column>
            <el-table-column
            prop="title"
            label="帮助课程名称"
           align="center"
            width="300"
            >
            </el-table-column>
             <el-table-column
            prop="appName"
            label="关联应用"
           align="center"
            width="200"
            >
            </el-table-column>
               <el-table-column
            prop="chapterNum"
            label="章节数量"
           align="center"
            >
            </el-table-column>
               <el-table-column
            prop="createTime"
            label="发布时间"
           align="center"
            width="200"
            >
            </el-table-column>
         <el-table-column label="启用状态" align="center">
            <template slot-scope="scope">
              <div class="buStatus" @click="changeStatus(scope)">
                
                <el-switch
                  v-model="scope.row.state == 0 ? false : true"
                  disabled
                >
                </el-switch>
              </div>
            </template>
          </el-table-column>
          
            <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="300"
            
            >
                <template slot-scope="scope">
                <el-button type="text" size="small" @click.stop="preview(scope.row)">预览</el-button>
                <el-button type="text" size="small" @click.stop="editPro(scope.row)">编辑</el-button>
                   <el-button type="text" size="small"  @click.stop="openPoster(scope.row)">查看链接海报</el-button>
                  <el-button type="text" size="small"  @click.stop="setAuth(scope.row)">设置权限</el-button>
                    <el-popover width="160" :ref="`popover-${scope.$index}`" class="ma10">
                    <p style="padding:10px 0"><i class="icon-al-delete-fill" style="color:#F56C6C"></i>确认删除此项吗？</p>
                     <span style="font-size:12px;padding-bottom:10px;display:block">删除不可恢复，请谨慎删除。</span>
                    <div style="text-align: right; margin: 0">
                        <el-button type="text" size="mini" @click="scope._self.$refs[`popover-${scope.$index}`].doClose()">
                        取消
                        </el-button>
                        <el-button type="danger" size="mini"  @click="deletPro(scope.row,scope.$index)">确定</el-button>
                    </div>
                   <el-button type="text" size="small"  slot="reference" style="color:red">删除</el-button>
                    </el-popover>
  </template>
            </el-table-column>
        </el-table>
         <el-pagination
            class="jiange"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="pageSizes"
            :page-size="PageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    <el-dialog
  title="查看链接海报"
  :visible.sync="centerDialogVisible1"
  width="440px"
  :append-to-body="true"
  center>
     <div class="dia-can">
                 <vue-canvas-poster :widthPixels="370" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
            </div>
            <div class="dia-btn" @click="$util.downloadFile(dowloadImgName,posterImg)">保存</div>
  <div class="linkdiv">
     帮助链接：{{link}}
    <span @click.stop="copy(link)" style="color:#409eff;cursor: pointer;">复制</span>
  </div>
</el-dialog>
    </div>
</template>
<script>
import {gethelpList,edithelpStatus,delhelp,getApplicationTypeList} from "@/api/index/index"  //企业列表、帮助基本信息修改接口、删除帮助、应用分类
export default { 
    name:'helpList',
     data: () => {
    return {
      radio1:'',
      dowloadImgName:'帮助文档海报',
      seletvalue:'',
        itemList1:[],
        link:'',
        centerDialogVisible1:false,
        search:'',
        search1:'',
        search2:'',
        search3:'',
        visible2:false,
                radio:'',
        seetext:'查看',
             pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        tableData: [],
        multipleSelection: [],
        edittype:0,
        tit:'',
        centerDialogVisible:false,
        totalNum:0,
        currentPage: 1, //初始页
        PageSize: 10, //每页的数据
        totalCount: 0,
        pageSizes:[10,20,30,40,50,100],
        newArry:[],
        itemList:[],
        data1: '',
        date2: '',
        checkList:[],
         options: [],
        value:'',
        value1:'',
        value2:'',
        start_time:'',
        end_time:'',
           posterImg: "",
              painting: {
                    width: '371px',
                    height: '420px',
                    background: '#f4f5f7',
                    borderRadius:'20px',
                    views: [
                        {
                            type: 'image',
                            url: '',
                            css: {
                                top: '0px',
                                left: '0px',
                                borderRadius:'20px 20px 0 0',
                                width: '371px',
                                height: '130px'
                            },
                        },
                        {
                            type:'text',
                            text: '',
                            css: {
                                top:'140px',
                                 width: "100%",
                            textAlign: "center",
                            fontSize: "14px",
                            maxLines: "2",
                            lineHeight: "20px"
                            }
                        },
                         {
                        type: 'qrcode',
                        content: '',
                        css: {
                            top: '200px',
                            left: '110px',
                            color: '#000',
                            width: '150px',
                            height: '150px'
                        }
                        },
                          {
                            type:'text',
                            text: '技术支持：北京和隆软件有限公司',
                            css: {
                                bottom:'20px',
                                left:'0px',
                                 width: "100%",
                                textAlign: "center",
                                fontSize: "12px",
                                maxLines: "1",
                                color: '#333',
                            }
                        }
                        // ....
                    ],
                },  
    }
},
    activated(){
  this.gethisInfo()
},
 created(){
 this.$nextTick(() =>{
            this.getthisType()
        })
 },
 mounted(){
   this.$bus.$off('state')
  this.$bus.$on("state", msg =>{   //vaPage传的时候的key是什么接收就必须是什么
   this.editbusiness(msg)
   })
 },
 methods: {
        // 获取应用分类
        getthisType(){
            this.itemList1 = []
             getApplicationTypeList({
                name:'',
                officialType:'',
             })
            .then(res => {
              if(res.data !==null){
                for (const key in res.data) {
                  this.itemList1.push({
                    value:res.data[key].id,
                    label:res.data[key].name,
                    children:res.data[key].children ? [] : ''
                  }) 
                  if(res.data[key].children){
                    for (const i in res.data[key].children) {
                        this.itemList1[key].children.push({
                            value:res.data[key].children[i].id,
                            label:res.data[key].children[i].name
                        })
                    }
                  } 
                }
              }else{
                    this.itemList1 = []
             }

            })
            .catch(err => {
            })
        },
    // 手动修改views
        handleChangeImg(data){
            this.painting.views[0].url = data.logo ? data.logo : require('../../assets/images/banner1.jpg')
             this.painting.views[1].text = data.title + '文档。'
             this.painting.views[2].content = this.$config.prUrl + '#/webenterprise/enhelpdetail?id='+ data.id
        },
  // 打开海报
  openPoster(data){
    if(data.state == 1){
      this.centerDialogVisible1 = true
      this.handleChangeImg(data)
      this.dowloadImgName = data.title + '帮助文档海报'
      this.link = this.$config.prUrl + '#/webenterprise/enhelpdetail?id=' + data.id + '&type=1'
    }else{
      this.$message.error('请先开启状态')
    }
  },
      success(src) {
             this.posterImg = src;
            },
            fail(err) {
                console.log('fail', err)
            },
    copy(link){
             let _self = this
      this.$copyText(link).then(
        function(e) {
            _self.$message.success('复制成功')
        },
        function(e) {
         _self.$message.error('复制失败')
        }
      );
    },
    // 打开复制弹框
    seeLink(data){
        this.link = this.$config.baseUrl + '/helpList'
        this.centerDialogVisible1 = true
    },
    // 打开预览页面
    preview(data){
        const newurl = this.$router.resolve({name: 'helpDetail', query: {id: data.id,state:data.state}})
        window.open(newurl.href,'_blank')
    },
    // 打开设置权限页面
    setAuth(data){
          this.$router.push({
            name: "authList",
            query:{
                id:data.id,
                title:data.title,
                state:data.state
            }
           })
    },
     // 企业分类筛选
        classSelect(value){
            this.currentPage = 1
            if(value){
                let index = value.length-1
                this.seletvalue = value[index]
                 this.gethisInfo()
                //  this.$refs.cascaderRef.dropDownVisible = false
            }else{
              this.seletvalue = ""
            }
           
        },
    // 搜索
    searchList(){
         if(this.search || this.search1){
           this.currentPage = 1
                this.gethisInfo()
            }else{
                this.gethisInfo()
            }
    },
    reset(){
      this.radio1 = ''
         this.search = ""
          this.search1 = ""
          this.search2 = ""
          this.search3 = ""
          this.seletvalue = "",
           this.radio = "",
           this.value2 = "",
            this.start_time = ""
            this.end_time = ""
           this.currentPage = 1
         this.gethisInfo()

    },
    // 新增帮助
    addHelp(){
        this.$router.push("/editHelpInfo")
    },
     // 修改帮助
        editPro(data){
           this.$router.push({
            name: "editHelpInfo",
            query:{
                id:data.id,
                state:data.state,
            }
           })
        },
    // 删除帮助
    deletPro(data,index){
           delhelp({
                id:data.id
              })
            .then(res => {
                if(res.code == 0){
                this.$message({
                type: 'success',
                message: '删除成功!'
             });
             this.currentPage = 1
            this.gethisInfo()
            }else{
                 this.$message.error(res.msg); 
            }
            this.$refs[`popover-${index}`].doClose()
            })
            .catch(err => {
            })
    },
    // 状态切换
      changeStatus(e){
       if(e.row.state == 1){
           this.$confirm('确认后用户将无法查看该帮助，仍要进行吗？', '帮助禁用', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                        this.editbusiness(e)
                        }).catch(() => {          
                        });
                    }else{
                        this.$confirm('帮助启用后不得随意删除帮助内容，请先进行预览、审核后再启用', '帮助启用', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                        this.editbusiness(e)
                        }).catch(() => {          
                        });
                    }
      },
         editbusiness(e){
           let state
           if(e.row.sedittype) {
            state = "0"
           }else{
            state = e.row.state == 1 ? '0' : '1'
           }
             edithelpStatus({
                id:e.row.id,
                state:state,
                    },'put')
                .then(res => {
                   if(!e.row.sedittype) this.$message.success('状态修改成功'); 
                    this.gethisInfo()
                })
                .catch(err => {
                })
        },
    // 时间选择
            dataSuccess(){
            if(this.value2){
             this.start_time = this.value2[0]
            this.end_time = this.value2[1]
            }else{
              this.start_time = ""
              this.end_time = ""
            }
            this.currentPage = 1
            this.gethisInfo()
        },
        // 不限
        allradio(type){
            this.currentPage = 1
             this[`radio${type}`] = ""
            this.gethisInfo()
        },
     // 获取列表
        gethisInfo(){
            let params = {
                name:this.search,
                id:this.search1,
                state:this.radio,
                officialType:this.radio1,
                appName:this.search2,
                appId:this.search3,
                classifyId:this.seletvalue,
                startTime:this.start_time,
                endTime:this.end_time,
                current: this.currentPage,
                size:this.PageSize,
            }
            gethelpList(params)
            .then(res => {
              this.itemList = res.data.records
             this.totalCount = res.data.total;
            })
            .catch(err => {
            })
        },
          handleSizeChange(val) {
       this.PageSize = val
       this.gethisInfo()
    },
    handleCurrentChange(val) {
      this.currentPage = val
       this.gethisInfo()
    },
 },
  destroyed(){
            this.$bus.$off('state')
  }
}
</script>
<style lang="scss" scoped>
#helpList{
    padding: 0 20px;
  .helpList_header {
    padding-bottom: 20px;
    border-bottom: 1px solid #ccc;
    .el-input {
      width: 250px;
      margin-right: 20px;
    }
  }
   .businessList-filter {
    padding-top: 10px;
    .businessList-filter-list {
      margin-top: 20px;
      .fl-rt {
        padding-left: 30px;
      }
    }
    .businessList-filter-list:first-child {
      margin-top: 0;
    }
  }
    .businessList-container {
    padding: 20px 0;
    .businessList-container-title {
      font-size: 18px;
      color: #409eff;
      background-color: rgba(242, 242, 242, 1);
      padding: 10px 20px;
      .mft {
        cursor: pointer;
      }
    }
    .helpList-container-table {
      .buStatus{
        width: 50px;
        margin: 0 auto;
      }
      .ma10{
        margin-left: 10px;
      }
      .el-switch {
        position: relative;
        z-index: 1 !important;
      }
      .el-switch.is-disabled {
        opacity: 1 !important;
      }
    }
    .jiange {
      margin-top: 20px;
    }
  }
}
::v-deep {
  .el-switch.is-disabled .el-switch__core {
    cursor: pointer !important;
    width: 50px !important;
  }
       .el-dialog{
      
            .el-dialog__header{
                background: #ccc;
               border-radius: 2px 2px 0 0;
            }
        }
                .dia-can{
        .canvas{
            position:relative !important;
            top: 0 !important;
            display: block;
            margin: 0 auto;
        }
    }
           .dia-btn{
            width: 100px;
        	height: 32px;
				line-height: 30px;
				font-size: 14px;
				padding: 0 16px;
				border-radius: 2px;
				font-family: inherit;
				border-width: 1px;
				border-style: solid;
				text-align: center;
				vertical-align: middle;
				box-sizing: border-box;
				cursor: pointer;
				transition: all .3s;
				background: $base-color-btn;
				color: #fff;
                margin: 20px auto;
                margin-bottom: 0;
    }
}
</style>